/* "Coming up" chips on Home (handoff screen 1): the next school events from today, US school year.
 * Fixed dates plus the rules for moving ones (Thanksgiving = 4th Thursday of November, etc.). */
const nthWeekday = (y, m, weekday, n) => { // m 0-11, weekday 0=Sun
  const d = new Date(y, m, 1);
  const shift = (weekday - d.getDay() + 7) % 7;
  return new Date(y, m, 1 + shift + 7 * (n - 1));
};
const lastWeekday = (y, m, weekday) => {
  const d = new Date(y, m + 1, 0);
  return new Date(y, m, d.getDate() - ((d.getDay() - weekday + 7) % 7));
};

const RULES = [
  { name: 'home.events.backToSchool', dot: 'yellow', date: (y) => new Date(y, 7, 15) },
  { name: 'home.events.hispanicHeritage', dot: 'coral', date: (y) => new Date(y, 8, 15) },
  { name: 'home.events.redRibbon', dot: 'coral', date: (y) => new Date(y, 9, 23) },
  { name: 'home.events.halloween', dot: 'yellow', date: (y) => new Date(y, 9, 31) },
  { name: 'home.events.veterans', dot: 'blue', date: (y) => new Date(y, 10, 11) },
  { name: 'home.events.thanksgiving', dot: 'green', date: (y) => nthWeekday(y, 10, 4, 4) },
  { name: 'home.events.winterBreak', dot: 'blue', date: (y) => new Date(y, 11, 20) },
  { name: 'home.events.newYear', dot: 'purple', date: (y) => new Date(y, 0, 1) },
  { name: 'home.events.mlk', dot: 'purple', date: (y) => nthWeekday(y, 0, 1, 3) },
  { name: 'home.events.blackHistory', dot: 'coral', date: (y) => new Date(y, 1, 1) },
  { name: 'home.events.day100', dot: 'yellow', date: (y) => new Date(y, 1, 10) },
  { name: 'home.events.valentines', dot: 'coral', date: (y) => new Date(y, 1, 14) },
  { name: 'home.events.womensHistory', dot: 'purple', date: (y) => new Date(y, 2, 1) },
  { name: 'home.events.readAcross', dot: 'blue', date: (y) => new Date(y, 2, 2) },
  { name: 'home.events.springBreak', dot: 'green', date: (y) => new Date(y, 2, 16) },
  { name: 'home.events.earthDay', dot: 'green', date: (y) => new Date(y, 3, 22) },
  { name: 'home.events.teacherWeek', dot: 'yellow', date: (y) => nthWeekday(y, 4, 1, 1) },
  { name: 'home.events.memorial', dot: 'blue', date: (y) => lastWeekday(y, 4, 1) },
  { name: 'home.events.graduation', dot: 'purple', date: (y) => new Date(y, 5, 1) },
];

/** The next `n` events from `today` (an event stays on its day). */
export function comingUp(today = new Date(), n = 4, t = (k) => k) {
  const start = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const all = [];
  for (const y of [start.getFullYear(), start.getFullYear() + 1]) {
    for (const r of RULES) all.push({ name: t(r.name), dot: r.dot, date: r.date(y) });
  }
  return all.filter((e) => e.date >= start).sort((a, b) => a.date - b.date).slice(0, n);
}

export function greeting(now = new Date()) {
  const h = now.getHours();
  return h < 12 ? 'home.greeting.morning' : h < 18 ? 'home.greeting.afternoon' : 'home.greeting.evening';
}
